export class FiltrosProspecto {
    idPros: number = 0;
    rucAdqui: string = '';
    FechaIni: string = '';
    FechaFin: string = '';
    Estado: string = '';
    Version: number = 0;
    user_id:any='';
}